import type { Omittable } from "@salestrak/ui";
// Display-name resolution for a user entity. Respects the
// `displayFullNames` preference: when true, prefer the user's full name
// (falling back to username, then email); when false, prefer the
// username (falling back to name, then email). Returns null when none
// of the fields are populated so callers can decide how to render the
// "no info yet" case.
//
// Pure — callers pull the preference value once (via useUserSettings /
// usePreferences) and pass it in. Avoids a hook-per-row in lists.

export type DisplayNameUser = Omittable<{
  name?: string | null;
  username?: string | null;
  email?: string | null;
}>;

export function getDisplayName(
  user: DisplayNameUser | null | undefined,
  displayFullNames: boolean,
): string | null {
  if (!user) return null;
  const name = trimOrNull(user.name);
  const username = trimOrNull(user.username);
  const email = trimOrNull(user.email);
  if (displayFullNames) {
    return name ?? username ?? email;
  }
  return username ?? name ?? email;
}

function trimOrNull(s: string | null | undefined): string | null {
  if (s == null) return null;
  const t = s.trim();
  return t.length === 0 ? null : t;
}
